import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box, Typography, Badge, Tooltip } from '@mui/material';
import UserAvatar from 'components/UserAvatar';
import cssStyles from '../../../utils/cssStyles';


const RootStyle = styled('div')(({ theme }) => ({
  '&:before': {
    ...cssStyles().bgBlur({ blur: 2, color: theme.palette.primary.darker }),
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
}));

const RootStyleKYC = styled('div')(({ theme }) => ({
  '&:before': {
    ...cssStyles().bgBlur({ blur: 2, color: theme.palette.error.dark }),
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
}));

const InfoStyle = styled('div')(({ theme }) => ({
  left: 0,
  right: 0,
  zIndex: 99,
  position: 'absolute',
  marginTop: theme.spacing(5),
  [theme.breakpoints.up('md')]: {
    right: 'auto',
    display: 'flex',
    alignItems: 'center',
    left: theme.spacing(3),
    bottom: theme.spacing(3),
  },
}));

// Status badge styles
const statusColor = (status, theme) =>
  status === 'suspended'
    ? theme.palette.error.main
    : theme.palette.success.main;

// const statusLabel = (status) =>
//   status === 'suspended'
//     ? 'Suspended'
//     : status === 'active'
//     ? 'Active'
//     : '';

ProfileCover.propTypes = {
  user: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
};

function statusLabel(status) {
  switch (status) {
    case 'suspended':
      return 'Suspended';
    case 'active':
      return 'Active';
    default:
      return '';
  }
}


export default function ProfileCover({ user, status }) {
  return (
    <RootStyle>
      <InfoStyle>
        <Tooltip title={statusLabel(status)} arrow>
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            badgeContent={
              status ? (
                <Box
                  sx={{
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 2,
                    fontSize: 12,
                    fontWeight: 700,
                    bgcolor: (theme) => statusColor(status, theme),
                    color: 'common.white',
                    boxShadow: 2,
                  }}
                >
                  {statusLabel(status)}
                </Box>
              ) : null
            }
          >
            <UserAvatar
              imageURL={user.image_url}
              name={user.display_name}
              sx={{
                mx: 'auto',
                borderWidth: 2,
                borderStyle: 'solid',
                borderColor: 'common.white',
                width: { xs: 80, md: 128 },
                height: { xs: 80, md: 128 },
              }}
            />
          </Badge>
        </Tooltip>
        <Box
          sx={{
            ml: { md: 3 },
            mt: { xs: 1, md: 0 },
            color: 'common.white',
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <Typography variant="h4">{user.display_name}</Typography>
          <Typography sx={{ opacity: 0.72 }}>ID: {user.user_id}</Typography>
        </Box>
      </InfoStyle>
    </RootStyle>
  );
}


ProfileCoverKYC.propTypes = {
  basic: PropTypes.object.isRequired,
};
export function ProfileCoverKYC({ basic }) {
  return (
    <RootStyleKYC>
      <InfoStyle>
            <UserAvatar
              imageURL={basic.image_url}
              name={`${basic.first_name} ${basic.last_name}`}
              sx={{
                mx: 'auto',
                borderWidth: 2,
                borderStyle: 'solid',
                borderColor: 'common.white',
                width: { xs: 80, md: 128 },
                height: { xs: 80, md: 128 },
              }}
            />
        <Box
          sx={{
            ml: { md: 3 },
            mt: { xs: 1, md: 0 },
            color: 'common.white',
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <Typography variant="h4">{basic.first_name} {basic.last_name}</Typography>
          <Typography sx={{ opacity: 0.72 }}>ID: {basic.user_id}</Typography>
        </Box>
      </InfoStyle>
    </RootStyleKYC>
  );
}
